const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const NONCE_KEY = 'laurenti-google-nonce';

let parsedGoogleRedirect;

export function isGoogleClientConfigured() {
  return Boolean(CLIENT_ID);
}

async function generateNoncePair() {
  const nonce = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32))));
  const hashBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(nonce));
  const hashedNonce = Array.from(new Uint8Array(hashBuffer))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
  return { nonce, hashedNonce };
}

export async function startGoogleSignIn() {
  if (!CLIENT_ID) {
    throw new Error('Google sign-in is not configured.');
  }

  const { nonce, hashedNonce } = await generateNoncePair();
  sessionStorage.setItem(NONCE_KEY, nonce);

  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    redirect_uri: `${window.location.origin}/login`,
    response_type: 'id_token',
    response_mode: 'fragment',
    scope: 'openid email profile',
    nonce: hashedNonce,
    prompt: 'select_account',
  });

  window.location.assign(`https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`);
}

export function consumeGoogleRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  if (parsedGoogleRedirect !== undefined) {
    return parsedGoogleRedirect;
  }

  const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '';
  const query = window.location.search.startsWith('?') ? window.location.search.slice(1) : '';
  const params = new URLSearchParams(hash || query);
  const idToken = params.get('id_token');
  const error = params.get('error');

  if (!idToken && !error) {
    parsedGoogleRedirect = null;
    return null;
  }

  const nonce = sessionStorage.getItem(NONCE_KEY);
  sessionStorage.removeItem(NONCE_KEY);
  window.history.replaceState({}, document.title, window.location.pathname);

  parsedGoogleRedirect = { idToken, error, nonce };
  return parsedGoogleRedirect;
}
